import api from '../api';
import { tokenService } from '../auth/tokenService';

export const dashboardService = {
  newUsers: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/users/new', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  distributionUsers: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/users/distribution', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  topProviders: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/rankings/providers', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  topCustomers: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/rankings/customers', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  services: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/services/status-distribution', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  requests: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/requests/status-distribution', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  mostPopularPackages: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/packages/popular', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  packageGain: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/packages/revenue', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  servicesByCategory: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/services/by-category', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  servicesBySubcategory: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/services/by-subcategory', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  lastSubCategories: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/categories/last-subcategories-added', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  tickets: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/support/tickets-by-period', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  activity: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/support/administrator-activity-by-period', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  pendingTickets: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/support/pending-tickets', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resolvedTickets: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/support/recently-resolved-tickets', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  bucksTransfer: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/tokens/transfers-by-period', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  numberBucks: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/tokens/distribution-by-type', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  bucksMovements: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/tokens/recent-movements', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  bucksGainsRegion: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/tokens/revenue-by-region', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  groupsDistribution: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/groups/status-distribution', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  topGroups: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/groups/top', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  groupActivity: async (params) => {
    try {
      const response = await api.get('dashboard/dashboard/groups/activity', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
}
